/**
 * Static options for legacy components that don't support i18n.
 * For v2 components with translation support, use the getter functions below.
 */

export const greaterThanOptions = [
    {
        value: 0.0,
        name: 'All',
    },
    {
        value: 0.3,
        name: 'Above 30%',
    },
    {
        value: 0.5,
        name: 'Above 50%',
    },
    {
        value: 0.8,
        name: 'Above 80%',
    },
];

export const sortByOptions = [
    {
        value: 'impressions',
        name: 'Impressions or Video Views',
    },
    {
        value: 'engagements',
        name: 'Engagements',
    },
    {
        value: 'fullMediaValue',
        name: 'Full Media Value',
    },
    {
        value: 'sponsorMediaValue',
        name: 'Sponsor Media Value',
    },
    {
        value: 'date',
        name: 'Date',
    },
];

export const orderByOptions = (sort = 'sponsorMediaValue') => [
    {
        value: 'asc',
        name: sort !== 'date' ? 'Low to High' : 'Oldest First',
    },
    {
        value: 'desc',
        name: sort !== 'date' ? 'High to Low' : 'Most Recent First',
    },
];

/**
 * Translated options for v2 components with i18n support.
 * Pass the `t` function from useTranslation() hook.
 */

export const getGreaterThanOptions = t => [
    {
        value: 0.0,
        name: t('greaterThanOptions.all'),
    },
    {
        value: 0.3,
        name: t('greaterThanOptions.above30'),
    },
    {
        value: 0.5,
        name: t('greaterThanOptions.above50'),
    },
    {
        value: 0.8,
        name: t('greaterThanOptions.above80'),
    },
];

export const getSortByOptions = t => [
    {
        value: 'impressions',
        name: t('sortByOptions.impressions'),
    },
    {
        value: 'engagements',
        name: t('sortByOptions.engagements'),
    },
    {
        value: 'fullMediaValue',
        name: t('sortByOptions.fullMediaValue'),
    },
    {
        value: 'sponsorMediaValue',
        name: t('sortByOptions.sponsorMediaValue'),
    },
    {
        value: 'date',
        name: t('sortByOptions.date'),
    },
];

export const getOrderByOptions = (t, sort = 'sponsorMediaValue') => [
    {
        value: 'asc',
        name:
            sort !== 'date'
                ? t('orderByOptions.lowToHigh')
                : t('orderByOptions.oldestFirst'),
    },
    {
        value: 'desc',
        name:
            sort !== 'date'
                ? t('orderByOptions.highToLow')
                : t('orderByOptions.mostRecentFirst'),
    },
];
